import { render } from "./serviceFeeModel.vue?vue&type=template&id=c020eaaa"
import script from "./serviceFeeModel.vue?vue&type=script&lang=js"
export * from "./serviceFeeModel.vue?vue&type=script&lang=js"

import "./serviceFeeModel.vue?vue&type=style&index=0&id=c020eaaa&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__